export default __webpack_public_path__ + "static/media/clover-img.bd2eca1d.webp";